import { userApiUrl } from "./api";
import { UserData } from "../types/User";
import qs from "qs";

const API_URL = "/Users";

export const getUserData = async (): Promise<UserData[]> => {
  try {
    const res = await userApiUrl.get<UserData[]>(API_URL);
    return res.data;
  } catch (error: any) {
    console.error(
      `Get all users error: ${error.response?.data?.message || error.message}`
    );
    return [];
  }
};

export const getUserListData = async (
  ids: number[],
  query?: string
): Promise<UserData[]> => {
  try {
    const res = await userApiUrl.get<UserData[]>(`${API_URL}/list`, {
      params: {
        ids: ids,
        query: query ? query : "",
      },
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: "repeat" }),
    });
    return res.data;
  } catch (error: any) {
    console.error(
      `Get user list error: ${error.response?.data?.message || error.message}`
    );
    return [];
  }
};

export const getUsersForPendingTask = async (
  userIs: number[]
): Promise<UserData[]> => {
  try {
    const res = await userApiUrl.get<UserData[]>(`${API_URL}/pending-tasks`, {
      params: {
        ids: userIs,
      },
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: "repeat" }),
    });
    return res.data;
  } catch (error: any) {
    console.error(
      `Get users for pending tasks error: ${
        error.response?.data?.message || error.message
      }`
    );
    return []; // Return empty array on error
  }
};

export const getDataById = async (id: number): Promise<UserData | null> => {
  try {
    const res = await userApiUrl.get<UserData>(`${API_URL}/${id}`);
    return res.data;
  } catch (error: any) {
    console.error(
      `Get users error: ${error.response?.data?.message || error.message}`
    );
    return null; // Return null on error
  }
};

export const createData = async (
  user: Partial<UserData>
): Promise<UserData | null> => {
  try {
    const res = await userApiUrl.post<UserData>(API_URL, user);
    return res.data;
  } catch (error: any) {
    console.error(
      `Create users error: ${error.response?.data?.message || error.message}`
    );
    return null;
  }
};

export const updateData = async (
  id: number,
  user: Partial<UserData>
): Promise<UserData | null> => {
  try {
    const res = await userApiUrl.put<UserData>(`${API_URL}/${id}`, user);
    return res.data;
  } catch (error: any) {
    console.error(
      `Update users error: ${error.response?.data?.message || error.message}`
    );
    return null;
  }
};

export const deleteData = async (id: number): Promise<boolean> => {
  try {
    await userApiUrl.delete(`${API_URL}/${id}`);
    return true;
  } catch (error: any) {
    console.error(
      `Delete users error: ${error.response?.data?.message || error.message}`
    );
    return false;
  }
};
